import React, { useState, useEffect } from "react";
import DefaultImage from "../../images/doc-pdf.png";

export default function ImageComponent({ image }) {
  const [newImage, setNewImage] = useState(image);

  useEffect(() => {
    setNewImage(image);
  }, [image]);

  const onError = () => {
    setNewImage(DefaultImage);
  };
  return <img src={newImage} onError={onError} alt="Random"></img>;
}
